const { default: gql } = require('graphql-tag');

const CREATE_CONVERSATION_THREAD = gql`
  mutation($input: CreateConversationThreadInput!) {
    createConversationThread(input: $input) {
      threadId
      displayId
      workItem {
        workId
        module
        displayId
      }
      asset {
        assetId
        name
        assetClass {
          name
          entityName
        }
      }
      status
      recipients {
        initiator {
          user {
            userId
            name
          }
          referenceId
          name
        }
        receiver {
          user {
            userId
            name
          }
          referenceId
          name
        }
      }
      chatActiveSession
    }
  }
`;

const UPDATE_CONVERSATION_THREAD = gql`
  mutation($input: UpdateConversationThreadInput!) {
    updateConversationThread(input: $input) {
      threadId
      displayId
      workItem {
        workId
        module
        displayId
      }
      asset
      status
      recipients {
        initiator {
          user
          referenceId
          name
        }
        receiver {
          user
          referenceId
          name
        }
      }
      chatActiveSession
    }
  }
`;

const UPDATE_CONVERSATION_THREAD_INTITATOR_INFO = gql`
  mutation($input: ConversationThreadIdentifierInput!) {
    updateConversationThreadInitiatorInfo(input: $input)
  }
`;

const CLOSE_CONVERSATION_THREAD = gql`
  mutation($input: CloseConversationThreadInput!) {
    closeConversationThread(input: $input)
  }
`;

export {
  CREATE_CONVERSATION_THREAD,
  UPDATE_CONVERSATION_THREAD,
  CLOSE_CONVERSATION_THREAD,
  UPDATE_CONVERSATION_THREAD_INTITATOR_INFO
};
